import { metadata } from '@paramount-streaming/blackbird';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { IAviaPlugin } from 'tag/ts/tag/player/adapters/avia/interfaces/IAviaPlugin';
import { AviaPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/AviaPlugin';
import { TPluginConfigFactory } from 'tag/ts/tag/player/adapters/avia/types/TPluginConfigFactory';

/**
 * @copyright © Paramount Streaming
 * @description Wraps metadata plugin from pluto-tv to be integrated with SmartTag
 */
export class MetadataPlugin extends AviaPlugin implements IAviaPlugin {
	package = metadata as unknown as TPluginConfigFactory;
	namespaceKey = 'plugin_metadata';

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				...argument,
				name: 'MetadataPlugin'
			}
		);
	}

	/**
	 * Should be used if params.STITCHER is non-empty
	 * @returns {boolean}
	 */
	shouldBeUsed() {
		return this.hasStitcherParams();
	}

	/**
	 * Returns parameters required to initialize metadata from pluto-tv
	 * @see {@link https://github.com/paramount-streaming/playback-javascript-lib/blob/main/libs/blackbird/src/player/adapters/avia/plugins/metadata/README.md}
	 * @example [Initializing metadata in Pluto tv demo] https://github.com/paramount-streaming/playback-javascript-lib/blob/main/app/src/smart-tag/useSmartTagVideoPlayer.ts#L111
	 */
	getFactoryParams() {
		return {
			...super.getFactoryParams()
		};
	}
}